<NavBar screenTitle="Roster"/>
<div class='columns is-marginless'>
    <div class='column is-half'>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Roster
                <span class='is-pulled-right'>
                    Total: {totalPlayers},
                    Active: {activePlayers}
                </span>
            </div>
            {#each $roster as player}
            <p class='panel-block roster-player'>
                <span class='panel-icon lineup-id' on:click="toggleActive(player.number)">
                    {#if player.active}
                    <i class="fas fa-lg fa-user-alt has-text-primary" aria-hidden="true"></i>
                    {:else}
                    <i class="fas fa-lg fa-user-alt-slash" aria-hidden="true"></i>
                    {/if}
                </span>
                <span class="{player.active ? '' : 'is-not-active'}">
                {player.last}, {player.first} (#{player.number})
                </span>
                <span class='panel-icon is-pulled-right has-text-danger' on:click="removePlayer(player.number)">
                    <i class="fas fa-lg fa-times-circle" aria-hidden="true"></i>
                </span>
            </p>
            {/each}
        </nav>
    </div>
    <div class='column is-half'>
        <nav class='panel'>
            <div class='panel-heading has-background-primary has-text-white'>
                Add Player
            </div>
            <div class='panel-block'>
                <div class='is-full-width'>
                    <div class='field'>
                        <div class='control'>
                            <input class='input' type='text' placeholder='First name' bind:value=newFirstName>
                        </div>
                    </div>
                    <div class='field'>
                        <div class='control'>
                            <input class='input' type='text' placeholder='Last name' bind:value=newLastName>
                        </div>
                    </div>
                    <div class='field'>
                        <div class='control'>
                            <input class='input' type='text' placeholder='Player number' bind:value=newNumber>
                        </div>
                    </div>
                    <div class='field'>
                        <div class='control'>
                            <button class='button is-primary is-pulled-right' on:click="addPlayer()">Add</button>
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    </div>
</div>

<script>
    import NavBar from './NavBar.html';

    export default {
        data() {
            return {
                newFirstName: '',
                newLastName: '',
                newNumber: null
            };
        },
        computed: {
            totalPlayers({$roster}) {
                return $roster.length;
            },
            activePlayers({$roster}) {
                return $roster.filter(function(player) {
                    return player.active;
                }).length;
            }
        },
        methods: {
            removePlayer(number) {
                const { roster, lineups } = this.store.get();
                let playerIdx = roster.findIndex(function (rosterPlayer) {
                    return rosterPlayer.number == number;
                });
                if (playerIdx > -1) {
                    roster.splice(playerIdx, 1);
                    this.store.set({ roster: roster });

                    lineups.forEach(function (lineup) {
                        Object.keys(lineup).forEach(function (lineupIdx) {
                            let player = lineup[lineupIdx];
                            if (player.number == number) {
                                lineup[lineupIdx] = {};
                            }
                        });
                    });
                    this.store.set({ lineups });

                }
            },
            addPlayer() {
                const { newFirstName, newLastName, newNumber } = this.get();
                const { roster } = this.store.get();
                let newPlayer = {
                    first: newFirstName,
                    last: newLastName,
                    number: newNumber,
                    active: true
                }
                let found = roster.find(function (player) {
                    return player.number == newPlayer.number;
                });

                if (!found) {
                    roster.push(newPlayer);
                    roster.sort(function (a, b) {
                        if (a.last == b.last) {
                            return a.first.localeCompare(b.first);
                        }
                        return a.last.localeCompare(b.last);
                    });
                } else {

                }
                this.set({ newFirstName: '', newLastName: '', newNumber: '' });
                this.store.set({ roster: roster });
            },
            toggleActive(number) {
                const { roster, lineups } = this.store.get();
                let playerIdx = roster.findIndex(function (rosterPlayer) {
                    return rosterPlayer.number == number;
                });
                if (playerIdx > -1) {
                    roster[playerIdx].active = !roster[playerIdx].active;
                    this.store.set({ roster: roster });

                    lineups.forEach(function (lineup) {
                        Object.keys(lineup).forEach(function (lineupIdx) {
                            let player = lineup[lineupIdx];
                            if (player.number == number) {
                                lineup[lineupIdx] = {};
                            }
                        });
                    });
                    this.store.set({ lineups });
                }
            }
        },
        components: {
            NavBar
        }
    };
</script>
<style>
    .roster-player {
        display: block;
        padding: 0.4em 0.75em;
    }

    .panel-icon {
        vertical-align: unset;
    }

    .fa-lg {
        line-height: 1.33333em;
    }

    .is-not-active {
        text-decoration: line-through;
    }
</style>
